import api from "./httpClient";
import { getRequestBranchIds, getStoredBranchIds } from "../auth/branchRequestContext";

function resolveBranchHeaderValue() {
  const runtimeBranchIds = getRequestBranchIds();
  const storedBranchIds = getStoredBranchIds();
  const branchIds = runtimeBranchIds.length > 0 ? runtimeBranchIds : storedBranchIds;
  return branchIds.length > 0 ? branchIds.join(",") : undefined;
}

/**
 * GET /api/ScheduledChange/History
 *
 * @param {object} [query] Optional query params (e.g. paging/sort if backend supports it)
 * @param {AbortSignal} [signal]
 */
export function getScheduledChangesHistory(query = {}, signal) {
  const branchHeaderValue = resolveBranchHeaderValue();

  return api.get("/ScheduledChange/History", {
    params: query,
    signal,
    headers: {
      "Content-Type": "application/json",
      ...(branchHeaderValue ? { "X-Branch-Id": branchHeaderValue } : {}),
    },
  });
}

/**
 * GET /api/ScheduledChange/Count?status={status}
 *
 * @param {string} status e.g. "Pending"
 * @param {AbortSignal} [signal]
 */
export function getScheduledChangesCount(status, signal) {
  return api.get("/ScheduledChange/Count", {
    params: { status },
    signal,
    headers: { "Content-Type": "application/json" },
  });
}

/**
 * GET /api/ScheduledChange/Details/{changeId}
 *
 * @param {string} changeId GUID of scheduled change history record
 * @param {AbortSignal} [signal]
 */
export function getScheduledChangeDetails(changeId, signal) {
  return api.get(`/ScheduledChange/Details/${changeId}`, {
    signal,
    headers: { "Content-Type": "application/json" },
  });
}

/**
 * PUT /api/ScheduledChange/Approve/{changeId}
 *
 * @param {string} changeId GUID of scheduled change history record
 * @param {AbortSignal} [signal]
 */
export function approveScheduledChange(changeId, signal) {
  return api.put(`/ScheduledChange/Approve/${changeId}`, null, {
    signal,
    headers: { "Content-Type": "application/json" },
  });
}

/**
 * PUT /api/ScheduledChange/Reject/{changeId}
 *
 * @param {string} changeId GUID of scheduled change history record
 * @param {AbortSignal} [signal]
 */
export function rejectScheduledChange(changeId, signal) {
  return api.put(`/ScheduledChange/Reject/${changeId}`, null, {
    signal,
    headers: { "Content-Type": "application/json" },
  });
}

/**
 * DELETE /api/ScheduledChange/Delete/{changeId}
 *
 * @param {string} changeId GUID of scheduled change history record
 * @param {AbortSignal} [signal]
 */
export function deleteScheduledChange(changeId, signal) {
  return api.delete(`/ScheduledChange/Delete/${changeId}`, {
    signal,
    headers: { "Content-Type": "application/json" },
  });
}

/**
 * PUT /api/ScheduledChange/Update/{changeId}
 *
 * @param {string} changeId GUID of scheduled change history record
 * @param {{ executeAtLocal: string|null, withdrawAtLocal: string|null }} payload
 * @param {AbortSignal} [signal]
 */
export function updateScheduledChange(changeId, payload, signal) {
  return api.put(`/ScheduledChange/Update/${changeId}`, payload, {
    signal,
    headers: { "Content-Type": "application/json" },
  });
}
